export function rumSendBeforeFrameworkInit() {
    // 3070 – before JS framework init
    window.Ya?.Rum?.sendTimeMark?.('3070');
}

export function rumSendFrameworkInited() {
    // 3036 - JS framework inited
    window.Ya?.Rum?.sendTimeMark?.('3036');
}

export function rumUpdatePage(page: string) {
    window.Ya?.Rum?.setVars?.({
        '-page': page,
    });
    window.Ya?.Rum?.updateErrors?.({
        page,
    });
}

export function rumLogError(err: unknown, params?: {block?: string; method?: string}) {
    window.Ya?.Rum?.logError?.(
        {
            level: window.Ya.Rum.ERROR_LEVEL.ERROR,
            ...params,
        },
        err,
    );
}
